export default {
      id: "logo-usage",
      viewBox: "0 0 210 65",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }